// @ts-nocheck
import React, { useEffect, useMemo } from 'react';
import { usePageActions } from '../contexts/PageActionsContext';

function sanitizeUrl(raw) {
  if (!raw || typeof raw !== 'string') return null;
  try {
    const u = new URL(decodeURIComponent(raw));
    if (u.protocol !== 'https:' && u.protocol !== 'http:') return null;
    return u.toString();
  } catch {
    return null;
  }
}

export default function EmbeddedResource({ title, src: srcProp }) {
  const src = useMemo(() => sanitizeUrl(srcProp), [srcProp]);
  const { setPageActions } = usePageActions();

  useEffect(() => {
    if (!src) return;
    setPageActions(
      <button
        type="button"
        className="btn btn-sm btn-primary rounded-3"
        onClick={() => window.open(src, '_blank', 'noopener,noreferrer')}
      >
        <i className="fa-solid fa-external-link-alt me-1" aria-hidden />
        New Window
      </button>,
    );
    return () => setPageActions(null);
  }, [src, setPageActions]);

  if (!src) {
    return (
      <div className="p-4">
        <p className="text-danger mb-0">This link could not be loaded in the app.</p>
      </div>
    );
  }

  return (
    <div className="embedded-resource d-flex flex-column h-100 min-vh-0 overflow-hidden">
      <iframe
        title={title || 'Embedded content'}
        src={src}
        className="flex-grow-1 w-100 border-0"
        style={{ display: 'block', minHeight: 0 }}
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
      />
    </div>
  );
}
